import { render, staticRenderFns } from "./DLProviderChart.vue?vue&type=template&id=875a40b8&"
import script from "./DLProviderChart.vue?vue&type=script&lang=js&"
export * from "./DLProviderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports